'use strict';
const Vue = require('vue/dist/vue.common.js');
const App = require('./App');

module.exports = function($) {

	return {
		init: init
	};

	function init() {
		launchApp();
		openForm();
	}

	function openForm() {
		var $form = $('.faq-form');

		$('.faq-form-open').on("click", function () {
			if (!$form.hasClass('active')) {
				$form.addClass('active');

				// Event for google analytics
				window[gtm4wp_datalayer_name].push({'event': 'faqFormOpen'});
			}
		});
	}

	function launchApp() {
		if (!document.querySelector('.faq-form')) {
			return;
		}

		new Vue(App);
	}

};
